import LPPigIcon from '/static/svg/icon-lp-pig.svg'
import LPPixIcon from '/static/svg/icon-lp-pix.svg'
import LPCardIcon from '/static/svg/icon-lp-card.svg'
import LPSecurityIcon from '/static/svg/icon-lp-security.svg'

const listItens = [
  {
    id: '1',
    text: 'As melhores condições para a sua negociação com opções que cabem no seu bolso',
    icon: <LPPigIcon />,
    title: 'Super descontos',
  },
  {
    id: '2',
    text: 'Além de pagar via boleto, você também pode quitar os débitos via PIX',
    icon: <LPPixIcon />,
    title: 'Pague com PIX',
  },
  {
    id: '3',
    text: 'Escolha como deseja pagar e parcele de acordo com a sua necessidade',
    icon: <LPCardIcon />,
    title: 'Personalize seu acordo',
  },
  {
    id: '4',
    text: 'Não se preocupe, suas informações e dados estão seguros e protegidos pela nossa equipe',
    icon: <LPSecurityIcon />,
    title: 'Mais segurança',
  },
]

export default listItens
